import RestFactory from '../rest/RestFactory';

class RestService {
  static get(path) {
    const rest = RestFactory.getDefaultRest();
    return rest({ method: 'GET', path: encodeURI(path) });
  }

  static getWithHandlers(path, successHandler, errorHandler) {
    this.get(path).then(
      response => successHandler(response),
      error => errorHandler(error)
    );
  }

  static post(path, entity) {
    const rest = RestFactory.getDefaultRest();
    return rest({ method: 'POST', path: encodeURI(path), entity });
  }

  static postWithHandlers(path, entity, successHandler, errorHandler) {
    this.post(path, entity).then(
      response => successHandler(response),
      error => errorHandler(error)
    );
  }
}

export default RestService;



/** WEBPACK FOOTER **
 ** ./src/services/RestService.js
 **/